import * as actionTypes from './actionTypes';


export const resetMultiAdvancedWifiState = () => {
  return {
    type: actionTypes.RESET_MULTI_ADVANCED_WIFI_STATE,
    
  };
}
  
export const createMultipleadvancedHomeWifi = (soloId) => {
    return {
      type: actionTypes.CREATE_MULTIADVANCEDWIFI,
      soloId
    };
  }
  export const createMultipleadvancedHomeWifiFailed = () => {
    return {
      type: actionTypes.CREATE_MULTIADVANCEDWIFI_FAILED
    }
  }
  export const createMultipleadvancedHomeWifiSuccess = () => {
    return {
      type: actionTypes.CREATE_MULTIADVANCEDWIFI_SUCCESS
    }
  }


  export const deleteMultipleadvancedHomeWifi = (soloId) => {
    return {
      type: actionTypes.DELETE_MULTIADVANCEDWIFI,
      soloId
    };
  }
  export const deleteMultipleadvancedHomeWifiFailed = () => {
    return {
      type: actionTypes.DELETE_MULTIADVANCEDWIFI_FAILED
    }
  }
  export const deleteMultipleadvancedHomeWifiSuccess = () => {
    return {
      type: actionTypes.DELETE_MULTIADVANCEDWIFI_SUCCESS
    }
  }

  

export const getEntitlement = () => {
    return {
        type: actionTypes.GET_ENTITLEMENT
    }
}

export const getEntitlementSuccess = (data) => {
    return {
        type: actionTypes.GET_ENTITLEMENT_SUCCESS,
        payload: data
    }
}

export const getEntitlementFailed = () => {
    return {
        type: actionTypes.GET_ENTITLEMENT_FAILED
    }
}

export const getMultiRouterBySoloId = (soloId) => {
    return {
        type: actionTypes.GET_MULTIROUTER_BY_SOLOID,
        soloId
    }
}

export const getMultiRouterBySoloISuccess = () => {
    return {
        type: actionTypes.GET_MULTIROUTER_BY_SOLOID_SUCCESS
    }
}

export const getMultiRouterBySoloIdFailed = () => {
    return {
        type: actionTypes.GET_MULTIROUTER_BY_SOLOID_FAILED
    }
}

export const resetMultiRouterErrorSuccess = () =>  ({ type: actionTypes.RESET_MULTIADVANCEDWIFI_ERROR_SUCCESS });
